<template>
    <div class="animated fadeIn">
    <b-card>
      <div class="mb-3">
          You are deleting {{allLabelSetCount}} label sets and {{imageCount}} images from dataset server.
      </div>
      <div>
        <b-form-checkbox v-model="onlySampleSet">
            Delete label sets which have only this sample set?
        </b-form-checkbox>
        <ul>
            <li v-for="labelSet in oneSampleSetLabelSets" :key="labelSet.label_set_id">{{labelSet.label_set_name}}</li>
        </ul>
      </div>
      <div>
        <b-form-checkbox v-model="multipleSets">
            Delete label sets which have multiple sample sets?
        </b-form-checkbox>
        <ul>
            <li v-for="labelSet in multipleSampleSetLabelSets" :key="labelSet.label_set_id">{{labelSet.label_set_name}}</li>
        </ul>
      </div>
      <div>
        <b-form-checkbox v-model="onlyImages" value="1" unchecked-value="0">
            Delete only images and keep sample set and label set?
        </b-form-checkbox>
      </div>
        <b-button class="mt-5" @click="deleteSample()">Delete</b-button>
    </b-card>
  </div>
</template>

<script>
import Services from '@/services/index';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      onlySampleSet: false,
      multipleSets: false,
      onlyImages: false,
      imageList: [],
      labelSetList: [],
      onlySampleSetLabelSets: [],
      multipleSetLabelSets: [],
      deletedSets: [],
    };
  },
  computed: {
    imageCount: {
      get() {
        return this.imageList.length;
      }
    },
    allLabelSetCount: {
      get() {
        return this.labelSetList.length;
      }
    },
    oneSampleSetLabelSets: function () {
      this.labelSetList.forEach((element) => {
        if (element.sample_sets.length === 1) {
          this.onlySampleSetLabelSets.push(element);
        }
      });
      return this.onlySampleSetLabelSets;
    },
    multipleSampleSetLabelSets: function () {
      this.labelSetList.forEach((element) => {
        if (element.sample_sets.length > 1) {
          this.multipleSetLabelSets.push(element);
        }
      });
      return this.multipleSetLabelSets;
    },
  },
  methods: {
    load() {
      Services.samples.list(this.$route.params.project_id, this.$route.params.id, { notpaginate: 1 }).then(({ data }) => {
        this.imageList = data.data;
      }).catch(() => {
      });
      Services.sampleSets.listLabelSets(this.$route.params.project_id, this.$route.params.id).then(({ data }) => {
        this.labelSetList = data;
      }).catch();
    },
    deleteSample() {
      let toBeChanged = [];
      toBeChanged = this.onlySampleSetLabelSets.concat(this.multipleSetLabelSets);
      // const deleted = [];
      if (this.onlySampleSet) {
        try {
          this.onlySampleSetLabelSets.forEach((element) => {
            Services.labelSets.delete(this.$route.params.project_id, element.label_set_id);
            this.deletedSets.push(element.label_set_id);
            delete toBeChanged[element];
          });
        } catch (error) {
          console.log(error);
        }
      }
      if (this.multipleSets) {
        try {
          this.multipleSetLabelSets.forEach((element) => {
            Services.labelSets.delete(this.$route.params.project_id, element.label_set_id);
            this.deletedSets.push(element.label_set_id);
            delete toBeChanged[element];
          });
        } catch (error) {
          console.log(error);
        }
      }
      try {
        toBeChanged.forEach((element) => {
          Services.labelSets.deleteLabelSetSample(this.$route.params.project_id, element.label_set_id, this.$route.params.id);
        // add strikethrough if succesfully completed delete
        });
        const booleanOnlyImages = this.onlyImages ? 1 : 0;
        Services.sampleSets.delete(this.$route.params.project_id, this.$route.params.id, { onlyImages: booleanOnlyImages });
      } catch (error) {
        console.log(error);
      }
      this.$router.push({ name: 'SampleSets' });
    },

  }
};
</script>
